import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { 
  getUrgentlyAdditionalCosts, 
  createUrgentlyAdditionalCost,
  clearLocalUrgentlyAdditionalCosts 
} from 'actions/urgentlyAdditionalCosts';

const useUrgentlyAdditionalCosts = () => {
  const dispatch = useDispatch();

  const getUrgentlyAdditionalCostsList = useCallback((params) => 
    dispatch(getUrgentlyAdditionalCosts(params)), [dispatch]);


  const createUrgentlyAdditionalCostRequest = useCallback((params) => 
    dispatch(createUrgentlyAdditionalCost(params)), [dispatch]);

  const clearLocalUrgentlyAdditionalCostsList = useCallback(() => 
    dispatch(clearLocalUrgentlyAdditionalCosts()), [dispatch]);

  return {
    getUrgentlyAdditionalCosts: getUrgentlyAdditionalCostsList,
    createUrgentlyAdditionalCost: createUrgentlyAdditionalCostRequest,
    clearLocalUrgentlyAdditionalCosts: clearLocalUrgentlyAdditionalCostsList
  };
};

export default useUrgentlyAdditionalCosts;
